import React from "react";
import {
  Show,
  BooleanField,
  TextField,
  ReferenceField,
  SimpleForm,
  DateField,
  NumberField,
  ArrayField,
  Datagrid,
} from "react-admin";

export const IsolatesShow = (props) => {
  return (
    <Show {...props}>
      <SimpleForm>
        <ReferenceField
          label="Culture"
          source="id_culture"
          reference="cultures"
          link="show"
        >
          <TextField source="code" />
        </ReferenceField>
        <TextField source="code" />
        <TextField source="isolate" />
        <BooleanField source="is_isolated" />
        <BooleanField source="has_sequence" />
        <BooleanField source="has_picture" />
        <DateField
          source="createdAt"
          locales="es-UY"
          options={{ timeZone: "UTC" }}
          showTime
        />
        <DateField
          source="updatedAt"
          locales="es-UY"
          options={{ timeZone: "UTC" }}
          showTime
        />
        {/* Phenotypes */}
        <div className="">PHENOTYPE</div>
        <TextField source="isolates_phenotype.size" label="Size" />
        <TextField source="isolates_phenotype.shape" label="Shape" />
        <TextField source="isolates_phenotype.elevation" label="Elevation" />
        <TextField source="isolates_phenotype.border" label="Border" />
        <TextField source="isolates_phenotype.surface" label="Surface" />
        <TextField source="isolates_phenotype.color" label="Color" />
        <TextField
          source="isolates_phenotype.observation"
          label="Observation"
          multiline
          minRows={6}
        />

        {/* Storage */}
        <div className="">STORAGE</div>

        <ArrayField source="isolates_storages" label="Isolates positions">
          <Datagrid>
            <ReferenceField
              source="id_storage"
              label="Storage"
              reference="storages"
              link={false}
            >
              <TextField source="storage" />
            </ReferenceField>
            <TextField source="cryobox_name" label="Cryobox name" />

            <NumberField source="cryobox_size" label="Size" initialValue="81" />
            <TextField source="cryobox_position" label="Position" />

            <TextField source="notes" label="Notes" multiline minRows={6} />
          </Datagrid>
        </ArrayField>
      </SimpleForm>
    </Show>
  );
};
